import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useMemo } from "react";

const menu = [
  { path: "/dashboard", label: "Dashboard" },
  { path: "/vehicles", label: "Vehicles" },
  { path: "/fuel", label: "Fuel" },
  { path: "/challans", label: "Challans" },
  { path: "/payments", label: "Payments" },
  { path: "/attendance", label: "Attendance" },
];

function Layout() {
  const navigate = useNavigate();

  const role = useMemo(() => {
    const user = JSON.parse(localStorage.getItem("uride_user") || "null");
    return user?.role || "operator";
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("uride_token");
    localStorage.removeItem("uride_user");
    navigate("/login");
  };

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="brand">URIDE Fleet</div>
        <nav className="menu">
          {menu.map((item) => (
            <NavLink key={item.path} to={item.path} className="menu-item">
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-footer">
          <div className="role-chip">Role: {role}</div>
          <button className="logout-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </aside>
      <main className="content">
        <header className="page-header">
          <h1>Fleet Management</h1>
        </header>
        <div className="page-body">
          <Outlet />
        </div>
      </main>
    </div>
  );
}

export default Layout;
